import * as ents from '@attain-apps/entities'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/**
 * Loads functional usage when organization assignments change and the current
 * functional usage methodology is Joint Use.
 */
export const loadForCurrentEntityOnOrgAssignmentChange = store.effects.create(
  (feature: Plugin['feature'], plugin: Plugin) =>
    ec.models.CollectionProducer.getEc$(ec.Name.Predefined.SpaceOrgAssignment, {
      waitUntilReady: true,
    }).pipe(
      rxjs.switchMap(orgAssignmentsEc =>
        orgAssignmentsEc.plugins.editingPlugin.feature.actions.submit.success
          .observe()
          .pipe(
            rxjs.withLatestFrom(plugin.selectors.functionalUsage.asObservable),
            rxjs.filter(
              ([, functionalUsage]) =>
                functionalUsage?.functionalizationMethodology ===
                ents.extra.space.Record.FunctionalUsage.Methodology.JointUse,
            ),
            rxjs.map(() =>
              feature.actions.loadForCurrentEntity.request
                .from(
                  '(effect) load for current entity on org assignment change',
                )
                .create(),
            ),
          ),
      ),
    ),
)
